import { collectTouch, getVisitorId, peekVisitorId } from "./collector";

export const ATTRIBUTION_VISITOR_COMMAND = "setAttributionVisitor";

const CTX_PATTERNS = [
  [/^od-confirm-(\d+)-iframe$/, "confirm"],
  [/^od-series-(\d+)-iframe$/, "event_series"],
  [/^od-membership-(\d+)-iframe$/, "membership_product"],
  [/^od-memberships-(\d+)-iframe$/, "team"],
  [/^od-giving-(\d+)-iframe$/, "giving_campaign"],
  [/^od-venue-ownership-(\d+)-events-iframe$/, "venue_ownership"],
  [/^opendate-gift-card-(\d+)$/, "gift_card_product"]
];

const FRAME_CTX_TYPES = [
  "confirm",
  "team",
  "venue_ownership",
  "giving_campaign",
  "membership_product",
  "gift_card_product",
  "class",
  "event_series",
  "storefront"
];
const FRAME_CTX_ID_PATTERN = /^[A-Za-z0-9_-]{1,100}$/;

export const ctxFromIframeId = (iframeId) => {
  for (const [pattern, type] of CTX_PATTERNS) {
    const match = pattern.exec(iframeId || "");
    if (match) return { type, id: match[1] };
  }
  return null;
};

const ctxFromFrame = (ctx) => {
  if (!ctx) return null;
  if (!FRAME_CTX_TYPES.includes(ctx.type)) return null;
  if (typeof ctx.id !== "string" && !Number.isInteger(ctx.id)) return null;
  const id = String(ctx.id);
  return FRAME_CTX_ID_PATTERN.test(id) ? { type: ctx.type, id } : null;
};

const originOf = (src) => {
  try {
    return new URL(src).origin;
  } catch (e) {
    return null;
  }
};

export const ATTRIBUTION_SENDER = "od_attribution";
export const ATTRIBUTION_ENABLED_COMMAND = "attributionEnabled";

const postVisitor = (iframe, from) => {
  const expected = originOf(iframe.src);
  const frame = iframe.contentWindow;
  if (!expected || !frame || iframe.contentDocument !== null) return false;
  const visitorUuid = peekVisitorId();
  if (visitorUuid) {
    frame.postMessage({ from, command: ATTRIBUTION_VISITOR_COMMAND, data: { visitorUuid }, unsolicited: true }, expected);
  }
  return true;
};

const postVisitorOnceLoaded = (iframe, from) => {
  try {
    if (postVisitor(iframe, from)) return;
    const onLoad = () => {
      try {
        if (postVisitor(iframe, from)) iframe.removeEventListener("load", onLoad, false);
      } catch (e) {}
    };
    iframe.addEventListener("load", onLoad, false);
  } catch (e) {}
};

export const listenForAttribution = ({ iframe, surface, from }) => {
  const listener = (event) => {
    try {
      const payload = event && event.data;
      if (!payload || typeof payload !== "object") return;
      if (payload.from !== ATTRIBUTION_SENDER || payload.command !== ATTRIBUTION_ENABLED_COMMAND) return;

      const expected = originOf(iframe.src);
      if (!expected || event.origin !== expected) return;
      if (!iframe.contentWindow || event.source !== iframe.contentWindow) return;

      const ctx = ctxFromIframeId(iframe.id) || ctxFromFrame(payload.ctx);
      if (ctx && payload.touch !== false && !window.__odAttrCollected) {
        window.__odAttrCollected = true;
        try {
          collectTouch({ origin: expected, ctx, surface });
        } catch (e) {}
      }

      let visitorUuid = null;
      try {
        visitorUuid = getVisitorId() || null;
      } catch (e) {}
      event.source.postMessage({ from, command: ATTRIBUTION_VISITOR_COMMAND, data: { visitorUuid } }, expected);
    } catch (e) {}
  };

  try {
    window.addEventListener("message", listener, false);
  } catch (e) {}

  postVisitorOnceLoaded(iframe, from);
};
